import { getDefaultFtpConfig, IFtpConfig } from './ftp/IFtpConfig';
import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer';
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer';
import deepmerge from 'deepmerge';


export class IrisrawModFtp extends IrisModContainer<IrisConfigContainer<IFtpConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModFtp.createIrisrawModFtpConfig)        
    }

    static createIrisrawModFtp(datas:IIrisModContainerConstParam) {        
        return new IrisrawModFtp(datas)
    }

    static createIrisrawModFtpConfig(data:IIrisConfigContainerConstParam) {                
        return new IrisConfigContainer<IFtpConfig>(deepmerge( {mod_settings:getDefaultFtpConfig()},data))
    }

}